import { render, staticRenderFns } from "./TotalItemCell.vue?vue&type=template&id=0aaec746&"
import script from "./TotalItemCell.vue?vue&type=script&lang=js&"
export * from "./TotalItemCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports